import React from 'react';
import {Form, Input, Button, Layout,  Alert, Select} from "antd";
import { registerFieldRules } from '../helpers/registerFieldRules';
import GLOBAL_ROLES, {GLOBAL_ROLES_RU} from '../../../constants/constants';
// const initialFeedbackStatus = {
//   name: "validating",
//   surname: "validating",
//   tel: "validating",           // для управляемой сигнализации валидации
//   phone: "validating",
//   email: "validating",
//   pass: "validating",
//   confirm: "validating",
// }

const rolesOrder = [GLOBAL_ROLES.operator, GLOBAL_ROLES.assistant, GLOBAL_ROLES.superOperator, GLOBAL_ROLES.careSupport, GLOBAL_ROLES.admin, GLOBAL_ROLES.companyManager];

const createAdminRoleOptions = () => {
  return rolesOrder.map(role => ({value: role, label:GLOBAL_ROLES_RU[role]}))
}

const rolesSelectOptions = createAdminRoleOptions()

const NewOperatorForm = ({buttonLoadingState, errorMessage, errorMessageHidden, handleValuesChange, handleSubmitFail, handleSubmit, form}) => {
  // const [feedBackStatus, setFeedbackStatus] = useState(initialFeedbackStatus) // для управляемой сигнализации валидации поля. Пока не разобрался.

  return (
    <Layout style={{margin:"15px", backgroundColor:"inherit"}}>
      <Form
        form = {form}
        name='test'
        onFinish = {handleSubmit}
        onFinishFailed = {handleSubmitFail}
        onValuesChange = {handleValuesChange}
        autoComplete="off"
        preserve={false}
      >
        <Form.Item
          hasFeedback="true"
          name="name"
          rules={registerFieldRules.operatorName}
          validateTrigger={["onChange", "onSubmit"]}
        >
          <Input
            size="large"
            placeholder="Имя"
            allowClear="true"
          >
          </Input>
        </Form.Item>
        <Form.Item
          hasFeedback="true"
          name="surname"
          rules={registerFieldRules.surname}
          validateTrigger={["onChange", "onSubmit"]}
        >
          <Input
            size="large"
            placeholder="Фамилия"
            allowClear="true"
          >
          </Input>
        </Form.Item>
        <Form.Item
          hasFeedback="true"
          name="tel"
          validateTrigger={["onChange","onSubmit", ]}
          rules={registerFieldRules.tel}
        >
          <Input
            size="large"
            placeholder="Номер телефона с кодом страны (+123456789)"
            allowClear="true"
            autoComplete='off'
          />
        </Form.Item>
        <Form.Item
          hasFeedback="true"
          name="email"
          rules={registerFieldRules.email}
          validateTrigger={["onChange", "onSubmit"]}
        >
          <Input
            size="large"
            allowClear
            placeholder="e-mail"
            autoComplete="off"
          />
        </Form.Item>
        <Form.Item
          name='role'
          validateTrigger={["onBlur"]}
          rules={registerFieldRules.role}
        >
          <Select
            // defaultValue="operator"
            style={{ width: 120 }}
            options={rolesSelectOptions}
            popupMatchSelectWidth={false}
            placeholder='Роль'
          />
        </Form.Item>
        <Form.Item
          hasFeedback="true"
          name="pass"
          validateTrigger={["onChange", "onBlur"]}
        autoComplete="off"
          rules={registerFieldRules.password}
        >
          <Input.Password size="large"  placeholder="password" autoComplete='off'/>
        </Form.Item>
        <Form.Item
          hasFeedback="true"
          name="confirm"
          dependencies={["pass"]}
          rules={registerFieldRules.passConfirm}
          validateTrigger={["onChange", "onSubmit"]}
        >
          <Input.Password size="large"  placeholder="Повторите пароль" autoComplete='off'/>
        </Form.Item>
        <Form.Item
          style={{display:'flex', justifyContent:'center'}}
        >
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            loading={buttonLoadingState}
          >
            Создать аккаунт
          </Button>
        </Form.Item>
        <Form.Item
          hidden={errorMessageHidden}
        >
          <Alert
            type="error"
            message={errorMessage}
            showIcon
          />
        </Form.Item>
      </Form>
    </Layout>
  );
};

export default NewOperatorForm;
